// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TokensIcons_wrapper__2TZRq","icon1":"TokensIcons_icon1__2bLei","icon2":"TokensIcons_icon2__3OO6M","single":"TokensIcons_single__1rbi9"};